import { create } from 'zustand';

/**
 * Global store for media preview modal
 * Allows any component to open the preview modal without prop drilling
 */
export const usePreviewStore = create((set) => ({
  isOpen: false,
  url: null,
  type: null, // 'image', 'video', 'audio'
  title: null,

  openPreview: (url, type, title = null) => {
    set({
      isOpen: true,
      url,
      type,
      title,
    });
  },

  closePreview: () => {
    set({
      isOpen: false,
      url: null,
      type: null,
      title: null,
    });
  },
}));
